import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import Theme from '../../styles/theme'
import { media, mediaMax } from '../../styles/media'

import GiftDetailedIcon from '../../components/icons/GiftDetailed'
import CreditCardDetailedIcon from '../../components/icons/CreditCardDetailed'
import FormDetailedIcon from '../../components/icons/FormDetailed'

const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mediaMax.md`
    h3 {
      font-size: 20px;
    }

    p {
      font-size: 16px;
    }
  `}

  svg {
    width: 80px;
    height: 80px;
    margin-bottom: 50px;
  }

  ${mediaMax.md`
    svg {
      margin-bottom: 24px;
    }

    &:not(:last-child) {
      margin-bottom: 50px;
    }
  `}
`

const Outer = styled.div`
  margin-bottom: 60px;

  h4 {
    font-size: 24px;
    font-weight: normal;
    margin: 0;
    margin-bottom: 20px;
    color: ${({ theme }) => theme?.['-ds-core-300']?.value};
  }

  p {
    max-width: 340px;
    margin: 0 auto;
    margin-bottom: 30px;
    font-size: 18px;
    line-height: 1.8;
  }

  ${media.md`
    p {
      min-height: calc(4em * 1.8);
    }
  `}
`

const Capitalized = styled.span`
  text-transform: capitalize;
`

const Steps = () => {
  const [t] = useTranslation('spelling')

  return (
    <Outer className="row">
      <StepWrapper className="col-md-4">
        <FormDetailedIcon />
        <h4>
          <Capitalized>{t('personalize')}</Capitalized> your voucher
        </h4>
        <p>
          Hit the BUY A RIPARIDE VOUCHER button and enter the details of the
          lucky recipient, the gift voucher value and your personal message.
        </p>
      </StepWrapper>
      <StepWrapper className="col-md-4">
        <CreditCardDetailedIcon />
        <h4>Log in and pay</h4>
        <p>
          Sign up or log in to Riparide, add your credit card and securely
          complete your payment.
        </p>
      </StepWrapper>
      <StepWrapper className="col-md-4">
        <GiftDetailedIcon color={Theme.brand.jungle} />
        <h4>Receive the voucher</h4>
        <p>
          We&apos;ll email you a link to download your voucher (pdf) within
          minutes. Print it out or send it to the lucky recipient and enjoy
          giving the gift of adventure.
        </p>
      </StepWrapper>
    </Outer>
  )
}

export default Steps
